import React, { Component } from 'react'
import MenuBar from '../../layouts/MenuBar'
import '../../styles/style.css'
import Footer from '../../layouts/Footer'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import { signUp } from '../../state-management/actions/auth/SignUpActions'
import PropTypes from 'prop-types'
import Helper from '../../utils/Helper'
import './index.css'
import { getCountries } from '../../state-management/actions/location/location-action'
import Banner from '../../assets/img/banner3.png'

class SignUp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      first: '',
      last: '',
      address: '',
      address2: '',
      email: '',
      alternateEmail: '',
      phone: '',
      alternatePhoneNumber: '',
      referral: '',
      passsword: '',
      state: '',
      houseNumber: '', // Added house number field to state
      plan: '',
      direction: '',
      amount: '',
      about: '',
      source: '',
      phoneError: '',
      terms: false,
      // city: '',
      country: '',
      payment_option: 'paystack',
    }
  }

  static propTypes = {
    load: PropTypes.bool.isRequired,
  }

  signUp = (e) => {
    e.preventDefault()
    const {
      first,
      last,
      address,
      address2,
      email,
      phone,
      alternatePhoneNumber,
      source,
      nin,
      lat,
      lng,
      direction,
      // city,
      houseNumber, // Include house number in destructuring
      country,
      state,
      payment_option,
    } = this.state
    const { location } = this.props
    const price = location.state ? location.state.amount : 17500
    const data = {
      firstName: first,
      lastName: last,
      address,
      address2: address,
      houseNumber, // Include house number in the data being sent
      lat: direction.lat,
      lng: direction.lng,
      // address: 'Atlantis 2 ologolo',

      email,
      phoneNumber: phone,
      alternatePhoneNumber: alternatePhoneNumber,
      language: 'english',
      allowEmail: true,
      plan: location.state ? location.state.planName : 'home',
      about_us: source,
      // city,
      country,
      state,
      payment_option,
    }

    const numbers = /^[0-9]+$/
    if (!phone.match(numbers)) {
      toast.info('Please enter only numbers')
    } else if (phone.length !== 11) {
      toast.info('invalid phone number')
    } else {
      this.props.signUp(data, price, this.props.history)
    }
  }

  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
    })

  handleInputChange = (event) => {
    const { name, type, checked, value } = event.target
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    })
  }

  handleNumber = (e) => {
    const { name, value } = e.target
    if (isNaN(Number(value))) return
    this.setState({ [name]: value })
  }

  handleSpaceBar = (e) => {
    if (e.keyCode === 32) e.preventDefault()
  }
  submitForm() {
    const { first, last, address, email, state, country, phone, alternatePhoneNumber, terms } = this.state
    return (
      first.length > 0 &&
      last.length > 0 &&
      address.length > 0 &&
      state.length > 0 &&
      // city.length > 0 &&
      country.length > 0 &&
      email.length > 0 &&
      phone.length === 11 &&
      terms
    )
  }

  componentDidMount() {
    this.props.getCountries()
  }

  displayStateAndRegions = () => {
    if (this.state.country === 'gh') {
      return this.props.countries
        .filter((country) => country.country === 'Ghana')
        .map((state) => <option value={state.state}>{state.state}</option>)
    } else if (this.state.country === 'cv') {
      return this.props.countries
        .filter((country) => country.country === "Cote d'Ivoire")
        .map((state) => <option value={state.state}>{state.state}</option>)
    } else {
      return this.props.countries
        .filter((country) => country.country === 'Nigeria')
        .map((state) => <option value={state.state}>{state.state}</option>)
    }
  }

  displayPaymentOptions = () => {
    let options_payments = [
      {
        option: 'paystack',
        description: 'Pay Online Using Paystack ',
      },
    ]
    return options_payments.map((payment_option) => (
      <option value={payment_option.option}> {payment_option.description} </option>
    ))
  }

  showPaymentAmount(state) {
    if (state) {
      return Helper.formatCurrency(state.amount)
    }
    if (this.state.payment_option === 'paddy-cover') {
      const amount = Number(state.amount) + 500
      return Helper.formatCurrency(amount)
    }
    return Helper.formatCurrency(17500)
  }

  render() {
    const { load, location } = this.props
    const isEnabled = this.submitForm()

    const { first, last, address, email, phone, alternatePhoneNumber, terms } = this.state
    return (
      <div>
        <MenuBar />

        <div className="container-fluid top">
          <div className="container-fluid pb-5 pt-5 ">
            <img src={Banner} alt="banner" className="over2"></img>
            <div className="row tite">
              <div className="col-sm-12 ">
                <h5 className="mt-5">Signup For</h5>
                <h6>{location.state ? location.state.plan : 'Residential Unlimited'}</h6>
                <form className="form-horizontal mt-3" onSubmit={this.signUp}>
                  <div className="form-group text-left">
                    <div className="d-flex">
                      <div className="mb-3 mr-auto col pl-0">
                        <label>First Name</label>
                        <input
                          type="text"
                          name="first"
                          value={first}
                          onChange={this.onChange}
                          className="form-control"
                          placeholder="First Name"
                        />
                      </div>

                      <div className="mb-3 col pr-0">
                        <label>Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="last"
                          value={last}
                          onChange={this.onChange}
                          placeholder="Last Name"
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        pattern="0[789]{1}[01]{1}[0-9]{8}"
                        title="Please enter your valid 11-digit phone number"
                        className="form-control"
                        name="phone"
                        value={phone}
                        maxLength="11"
                        placeholder="Phone number"
                        onChange={this.handleNumber}
                        onKeyDown={this.handleSpaceBar}
                      />
                    </div>

                    <div className="mb-3">
                      <label>Alternate Phone Number</label>
                      <input
                        type="tel"
                        pattern="0[789]{1}[01]{1}[0-9]{8}"
                        title="Please enter your valid 11-digit phone number"
                        className="form-control"
                        name="alternatePhoneNumber"
                        value={alternatePhoneNumber}
                        maxLength="11"
                        placeholder="Phone number"
                        onChange={this.handleNumber}
                        onKeyDown={this.handleSpaceBar}
                      />
                    </div>

                    <div className="mb-3">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.onChange}
                        className="form-control"
                        placeholder="Contact email address"
                      />
                    </div>

                    <div className="mb-3">
                      <label>How Did You Hear About Us?</label>
                      <select className="form-control" name="source" onChange={this.onChange}>
                        <option value="">Select</option>
                        <option value="bbn">Big Brother Naija</option>
                        <option value="google ads">Google Ads</option>
                        <option value="facebook">Facebook</option>
                        <option value="linkedin">LinkedIn</option>
                        <option value="flyer">Flyer</option>
                        <option value="billboard">Billboard</option>
                        <option value="mobile advert">Mobile Advert</option>
                        <option value="friend">Friend</option>
                        <option value="instagram">Instagram</option>
                        <option value="television">Television</option>
                        <option value="radio">Radio</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>Country</label>
                      <select className="form-control" name="country" onChange={this.onChange} required>
                        <option required>Select Country</option>

                        <option value="ng"> Nigeria</option>
                        <option value="gh"> Ghana</option>
                        <option value="cv"> Cote d'Ivoire</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>State</label>
                      <select
                        className="form-control"
                        name="state"
                        onChange={(e) => {
                          this.onChange(e)
                        }}
                        required
                      >
                        <option>Select State</option>
                        {this.displayStateAndRegions()}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>House Number</label>
                      <input
                        type="text"
                        name="houseNumber"
                        value={this.state.houseNumber}
                        onChange={this.onChange}
                        className="form-control"
                        placeholder="House Number"
                      />
                    </div>

                    <div className="mb-3">
                      <label>Physical Address <span className="text-danger">*</span></label>
                      <textarea
                        name="address"
                        value={this.state.address}
                        onChange={this.onChange}
                        className="form-control"
                        placeholder="Physical Address"
                        required
                      />
                    </div>

                    <>
                      <input
                        type="checkbox"
                        name="terms"
                        className="check"
                        checked={terms}
                        onChange={this.handleInputChange}
                      />
                      <label htmlFor="vehicle1">
                        By signing up, you agree to our{' '}
                        <a href="http://wifi.com.ng/terms" className="terms-link">
                          Terms and Conditions
                        </a>
                      </label>
                    </>
                    <div className="mb-3">
                      {load ? (
                        <input
                          disabled={true}
                          className="btn signup-btn w-100 text-white"
                          value="Submitting..."
                          type="submit"
                        />
                      ) : (
                        <input
                          disabled={!isEnabled}
                          className="btn signup-btn w-100 text-white"
                          value="Proceed"
                          type="submit"
                        />
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <Footer />
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  load: state.signUp.load,
  countries: state.location.countries,
  gettingCities: state.location.gettingCities,
})

export default connect(mapStateToProps, {
  signUp,
  getCountries,
})(SignUp)
